const locale = {
  WELCOME_TO_ALLPASS: 'Welcome to Allpass.ai',
  WELCOME_DESCRIPTION: 'Effortlessly onboard customers while ensuring compliance with regulations.',
};

export default locale;
